<template>
  <AsideMenuDesktop
    v-if="isDesktop"
    :is-user-data-ready="isUserDataReady"
    :routes="routes"
  />
  <MainMenuMobile
    v-else
    :is-user-data-ready="isUserDataReady"
    :routes="routes"
    :lock-scroll="true"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import AsideMenuDesktop from './aside-menu-desktop';
import MainMenuMobile from './main-menu-mobile';

export default {
  props: {
    isUserDataReady: {
      type: Boolean,
      required: true,
    },
    routes: {
      type: Array,
      default: () => [],
    },
  },
  components: { AsideMenuDesktop, MainMenuMobile },
  computed: {
    ...mapGetters('layoutModule', ['isDesktop']),
  }
};
</script>
